import styled from '@emotion/styled'
import { css } from '@emotion/react'
import Typography from '@material-ui/core/Typography';
import colorPalette from '~/theme/colorPalette.js';

const FormLabel = (props) => {
  const { must = false, children } = props;

  return (
    <Label must>
      {children}
      {must && <span> ※</span>}
    </Label>
  );
}

export default FormLabel;

const Label = styled.div`
  font-size: 1.8rem;
  margin-left: 1rem;
  text-align: left;
  &:before {
    content: "● ";
    color: ${colorPalette.orange};
  }
  span{
    content: ${ props => props.must &&  " ※"};
    color: ${colorPalette.orange};
    font-size: 1.8rem;
  }
`
